import {selectFinancesResource} from '~/redux/finances';
import {selectFinancesData} from '~/redux/finances/financesPrimitives';

export function selectFiatProviders(state: AppModel) {
    return selectFinancesData(state)?.providers;
}

export function selectProvidersResource(state: AppModel) {
    return selectFinancesResource(state).mapSuccess(r => r.providers);
}
